import LoadingBlock from "../LoadingBlock";
import styles from "../styles/SchoolFeedBlock.module.scss";
import SchoolFeedList from "../../../schoolfeed/ContentPostDisplay/SchoolFeedList";
import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { INewsBlockProps } from "./NewsBlock";
import { useSchoolFeedBlockAndWidgetContent } from "../../../schoolfeed/hooks/useSchoolFeedBlockAndWidgetContent";
import FeedHeader from "./FeedListHeader";
import { useStores } from "../../../../stores/useStores";
import { FetchMoreNewsButton } from "../../TerracedGridTheme/NewsBlock/FetchMoreNewsButton";
import { Box } from "@radix-ui/themes";

const SchoolFeedBlock: React.FC<INewsBlockProps> = observer(
  (props: INewsBlockProps) => {
    const { organizationStore } = useStores();

    const {
      contentItems,
      isValidating,
      mutate,
      currentView,
      setCurrentView,
      setSize,
      showViewMore,
      getItemAtIndex,
      total,
    } = useSchoolFeedBlockAndWidgetContent({
      organization_id: organizationStore.currentOrganization.id,
      organization_pk: organizationStore.currentOrganization.id,
    });

    useEffect(() => {
      props.blockObj.setAttributes({
        asyncLoaded: !props.blockObj.asyncLoaded,
      });
    }, [contentItems[currentView]]);

    if (isValidating[currentView] && contentItems[currentView].length === 0) {
      return <LoadingBlock />;
    }

    async function handleDelete() {
      await mutate[currentView]();
    }

    const handleCurrentViewChange = (view: string) => {
      setCurrentView(view);
    };

    let currentViewOptions = [
      { value: "news", label: "News" },
      { value: "events", label: "Events" },
    ];
    if (
      !contentItems ||
      contentItems?.news?.length === 0 ||
      contentItems?.events?.length === 0
    ) {
      currentViewOptions = [];
    }

    const fetchContent = () => {
      setSize[currentView]((s) => s + 1);
    };

    return (
      <div className={styles.container}>
        <FeedHeader
          currentView={currentView}
          handleCurrentViewChange={handleCurrentViewChange}
          currentViewOptions={currentViewOptions}
          content={contentItems[currentView] || []}
          mutate={mutate[currentView]}
          toggleID={props.blockObj.id}
        />
        {contentItems && contentItems[currentView].length > 0 ? (
          <SchoolFeedList
            showMedia={props.blockObj.sizeX > 1}
            allowCuration={true}
            content={contentItems[currentView]}
            handleDelete={handleDelete}
            totalItemCount={total[currentView]}
            getItemAtIndex={getItemAtIndex[currentView]}
          />
        ) : (
          <div>No content found</div>
        )}
        {showViewMore[currentView] && (
          <Box pt={"2"}>
            <FetchMoreNewsButton
              contentType={currentView}
              onClick={fetchContent}
              isLoading={isValidating[currentView]}
            />
          </Box>
        )}
      </div>
    );
  },
);

export default SchoolFeedBlock;
